import React, { Component } from 'react';
import * as Constants from '../../../common/Global/constants';
import {SearchSpan,TableRadioButton,DialogSaveButton} from '../../../common/Global/globalStyles.style';
import FilterDropDown from '../../../common/DropdownMenus/FilterDropdown';
import Pagination from '../../../common/Global/pagination';
import {isEmptyVariable,sortTable,truncateString,isEmptyArray} from '../../../common/Global/commonFunctions';
import {Modal} from 'react-bootstrap';
import AlertDialog from '../../../common/AlertDialog';

const sortShortName = "shortName";
const sortName = "name";
const sortDescription = "description";
const mTAssignmentType = "Assignment Type";

class AssertionAssignmentList extends Component{
    constructor(props){
        super(props);
        this.state = {
            componentDidMountFlag:false,
            apiSearchKey:"",
            searchkey:"",
            currentPageNo: 1,
            showLoader:false,
            resultSize:Constants.RESULT_SIZE,
            totalCount:0,
            datalist:[],
            oldDatalist:[],
            resultSizePlaceholder:Constants.RESULT_SIZE,
            resultSizeArr:Constants.RESULT_SIZE_DD_ARR,
            sort:"",
            sortDir:"asc",
            selectedTypeObj:{},
			selectedId:"",
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        }
    }

    componentDidMount(){
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && 
        this.props.showOtherMasterDialog){
            this.setState({
                apiSearchKey:"",
                searchkey:"",
                currentPageNo: 1,
                showLoader:false,
                resultSize:Constants.RESULT_SIZE,
                totalCount:this.props.assignmentTypeList.length,
                datalist:this.props.assignmentTypeList,
                oldDatalist:this.props.assignmentTypeList,
                resultSizePlaceholder:Constants.RESULT_SIZE,
                resultSizeArr:Constants.RESULT_SIZE_DD_ARR,
                sort:"",
                sortDir:"asc",
				selectedId:"",
				selectedTypeObj:{},
            })
        }
    }

    handleChangeSearch = (e) => {
        const { name, value } = e.target;
        this.setState({ 
            [name]: value,
            apiSearchKey:value
        });
    }

    onSearchIconClick = () => {
        let list = [...this.state.oldDatalist];
        list = list.filter(item => item.name.toLowerCase().includes(this.state.searchkey.toLowerCase()))
        this.setState({
            currentPageNo:1,
            datalist:list,
            totalCount:list.length
        })
    }

    handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        })
    }

    onEnterBtnPress = (e) => {
        var code = e.keyCode || e.which;
        let list = [...this.state.oldDatalist]
        list = list.filter(item => item.name.toLowerCase().includes(this.state.searchkey.toLowerCase()));
        if(code === 13){
            this.setState({
                currentPageNo:1,
                datalist:list,
                totalCount:list.length
            })
        }
    }

    resultSizeDropdownClick = (item,selectedIndex) => {
        let tempArr = this.state.resultSizeArr;
        let placeholder = "";

        for(const [i,value] of tempArr.entries()){
            if(i === selectedIndex){
                tempArr[i].isSelected = true;
                placeholder = value.label ;
            }else{
                tempArr[i].isSelected = false;
            }
        }
        
        this.setState({
            resultSizeArr:tempArr,
            resultSize:item.label,
            resultSizePlaceholder:placeholder
        })
    }

    handleSelection = (e) => {
        let isChecked = e.target.checked;
        let index = e.target.name;

		let selectedId = "";
		let selectedTypeObj = {};
		if(isChecked){
            selectedId = this.state.datalist[index].assignmentTypeId;
            selectedTypeObj = this.state.datalist[index];
        }
		this.setState({
			selectedId:selectedId,
			selectedTypeObj:selectedTypeObj
		})
    }

    sortTableLocal = (sortColumn) => {
        const { datalist, sort, sortDir } = this.state;
        const newSortDir = (sort === sortColumn && sortDir === 'asc') ? 'desc' : 'asc';

        const sortedList = [...datalist].sort((a, b) => {
            if (!a[sortColumn]) return 1;
            if (!b[sortColumn]) return -1;
            const aValue = a[sortColumn].toString().toLowerCase();
            const bValue = b[sortColumn].toString().toLowerCase();

            return newSortDir === 'asc' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
        });

        this.setState({
            datalist: sortedList,
            sort: sortColumn,
            sortDir: newSortDir,
            currentPageNo: 1 // reset to first page after sort
        });
    }

    returnSelectedMasterId = () => {
		if(isEmptyVariable(this.state.selectedId)){
			if(this.props.masterType === mTAssignmentType){
                this.setState({
                    showAlertDialogInfo:true,
                    alertDialogMessageInfo:"Select Assignment type"
                })
			}
		}else{
			this.props.handleSelectOtherMasterDialogSaveClose(this.state.selectedId);
		}
    }
    /*****************************API*********************************/
    onChangePage = (page) => {
        // update state with new page of items
        if(page !== this.state.currentPageNo){
            this.setState({
                currentPageNo:page,
            });
        }
    }

    render(){
        const startIndex = (this.state.currentPageNo - 1) * this.state.resultSize;
        const endIndex = startIndex + this.state.resultSize;
        const paginatedItems = this.state.datalist.slice(startIndex, endIndex);
        return(
            <section>
                <Modal className="task-select-table-dialog custom-dialog"
                    show={this.props.showOtherMasterDialog} 
                    backdrop="static">
                    <Modal.Header>
                        <h5>{this.props.masterType}</h5>
                        <button 
                            onClick={this.props.handleSelectOtherMasterDialogClose}
                            type="button" data-dismiss="modal">
                            <span class="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <hr />
                    <div className="modal-body">
                        {
                            this.state.showLoader &&
                            <div class="loader"></div>
                        }
                        {
                            // Need to check component did mount flag, other wise until api is called,
                            // it shows no items found layout.
                            // this.state.componentDidMountFlag &&
                            <div className="body-wrapper">
                                <div className="search-addnew-bg" style={{marginTop:0}}>
                                    <div className="search-addnew">
                                        
                                        <div className="search-filter-layout" style={{position:"relative"}}>
                                            <FilterDropDown
                                                placeholder={this.state.resultSizePlaceholder}
                                                dropdownArr={this.state.resultSizeArr}
                                                onDropDownItemClick={this.resultSizeDropdownClick}
                                                addBorder={true}
                                                themeSettings={this.props.themeSettings}
                                                mleft={0}
                                            />
                                            <div className="search-col m-l-10" style={{border:"1px solid #e5e5e5"}}>
                                                <input 
                                                    name="searchkey" 
                                                    type="text"
                                                    onChange={this.handleChangeSearch}
                                                    placeholder="Search" 
                                                    onKeyPress={this.onEnterBtnPress}
                                                    value={this.state.searchkey}
                                                />
                                                <SearchSpan 
                                                themeSettings={this.props.themeSettings}
                                                onClick = {this.onSearchIconClick} className="material-icons"> search </SearchSpan>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style={{position:"relative"}}>
                                    {
                                        !isEmptyArray(paginatedItems) && 
                                        <div className="common-tab-bg">
                                            <div className="common-table" style={{width:"100%",border:"1px solid #e5e5e5"}}>
                                                <table className="table">
                                                    <thead>
                                                        <tr>
                                                            <th className="text-center" width={"8%"}></th>
                                                            <th className="text-center" width={"5%"}>No</th>
                                                            <th  className="c-pointer" onClick={this.sortTableLocal.bind(this,sortShortName)}>
                                                                <div className="sort-header">Short Name
                                                                <span className={(this.state.sort === sortShortName)?"material-icons":"material-icons hide-sort-arrow"}>{this.state.sortDir === "asc"?"arrow_upward":"arrow_downward"}</span>
                                                                </div>
                                                            </th>
                                                            <th width={"35%"} className="c-pointer" onClick={this.sortTableLocal.bind(this,sortName)}>
                                                                <div className="sort-header">Name
                                                                <span className={(this.state.sort === sortName)?"material-icons":"material-icons hide-sort-arrow"}>{this.state.sortDir === "asc"?"arrow_upward":"arrow_downward"}</span>
                                                                </div>
                                                            </th>
                                                            <th width={"35%"} className="c-pointer" onClick={this.sortTableLocal.bind(this,sortDescription)}>
                                                                <div className="sort-header">Description
                                                                <span className={(this.state.sort === sortDescription)?"material-icons":"material-icons hide-sort-arrow"}>{this.state.sortDir === "asc"?"arrow_upward":"arrow_downward"}</span>
                                                                </div>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    {
                                                        !isEmptyArray(paginatedItems) && 
                                                        paginatedItems.map((item,idx) => {

                                                            return <tr>
                                                                <td>
                                                                    <TableRadioButton
                                                                        themeSettings={this.props.themeSettings}>
                                                                        <input 
                                                                            type="checkbox"
                                                                            name={idx}
                                                                            id={item.assignmentTypeId}
                                                                            onChange={this.handleSelection}
																			checked={item.assignmentTypeId==this.state.selectedId?true:false}
                                                                        />
                                                                        <label htmlFor={item.assignmentTypeId} 
                                                                        style={{marginLeft:6}}></label>
                                                                    </TableRadioButton>
                                                                </td>
                                                                <td className="text-center">{((this.state.currentPageNo - 1) * this.state.resultSize) + (++idx)}</td>
                                                                <td>{item.shortName}</td>
                                                                <td>{item.name}</td>
                                                                <td>{truncateString(item.description,Constants.OTHERMASTERS_STRING_LENGTH)}</td>
                                                            </tr>
                                                        })
                                                    }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    }
                                    {
                                        // this.state.componentDidMountFlag && 
                                        isEmptyArray(paginatedItems) &&
                                        <div class="no-items-layout">
                                            <div class="no-items-card">
                                                <h6>
                                                {
                                                    isEmptyVariable(this.state.apiSearchKey)?
                                                    Constants.NO_RECORDS_WARNING
                                                    :
                                                    Constants.EMPTY_SEARCH_WARNING
                                                }
                                                </h6>
                                            </div>
                                        </div>
                                    }
                                    <div className="pagination-layout">
                                        <div className="row custom-row">
                                            <div className="col-md-9 custom-col">
                                            {
                                                (this.state.datalist.length > this.state.resultSize) && 
                                                <Pagination 
                                                    totalLength ={this.state.totalCount} 
                                                    items={this.state.datalist} 
                                                    onChangePage={this.onChangePage} 
                                                    pageSize={this.state.resultSize}
                                                    currentPageNo = {this.state.currentPageNo}
                                                    initialPage={this.state.currentPageNo}
                                                    themeSettings={this.props.themeSettings} />
                                            }
                                            </div>
                                            <div className="col-md-3 custom-col">
                                                <p>{"Total Records: "+this.state.totalCount}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* {
                                    !isEmptyVariable(this.state.otherMasterFormErr) &&
                                    <span className="cm-error">{this.state.otherMasterFormErr}</span>
                                } */}
                                <div className="modal-close-save m-t-15">
                                    <div className="close-save-col">
                                        <button onClick={this.props.handleSelectOtherMasterDialogClose} type="button" 
                                        className="modal-close m-b-0">Cancel</button>
                                        {!isEmptyArray(this.state.datalist) &&
                                            <DialogSaveButton  themeSettings={this.props.themeSettings} 
                                            onClick={this.returnSelectedMasterId} type="button" 
                                            className="modal-save m-b-0">{this.props.proceedBtnLabel}</DialogSaveButton>
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </Modal>
                <AlertDialog
                    showAlertDialog={this.state.showAlertDialogInfo}
                    handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                    type={Constants.ALERT_TYPE_ALERT}
                    alertDialogMessage={this.state.alertDialogMessageInfo}
                    proceedBtnClick={this.handleAlertDialogCloseInfo}
                    proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                    themeSettings={this.props.themeSettings}
                />
            </section>
        )
    }
}

export default AssertionAssignmentList;